import React from "react";
import { Box, Grid, InputAdornment } from "@mui/material";
import ByzMuiTextField from "../../../inputs/ByzMuiTextField";
import SearchIcon from "@mui/icons-material/Search";
import ByzMuiDataGrid from "../../../data-grid";
import { columns, initialData, treeViewData, treeViewData2 } from "./data";
import ByzMuiTreeView from "../../../data-grid/tree-view";
import ByzMuiTypography from "../../../inputs/ByzMuiTypography";
import { ByzMuiCheckBox } from "../../../ByzMuiCheckBox";
import { useTranslate } from "src/locales";

//MPOGLU;443876;19022025
interface PrintModalProps {
  type: 1 | 2 | 3; // type prop'u yalnızca 1, 2 veya 3 değerlerini alabilir
  onClose: () => void;
}

const PrintModal: React.FC<PrintModalProps> = ({ type, onClose }) => {
  const { t } = useTranslate(); 

  return (
    <Box>
      {type === 1 && (
        <Box>
          {/* Type 1 Yazdır */}
          <ByzMuiTextField
            placeholder={t("print.form-search")}
            type="search"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "16px",
                backgroundColor: "#f4f7fe",
                marginBottom: "4px",
              },
            }}
          />
          <Box>
            <ByzMuiDataGrid
              rows={initialData}
              columns={columns}
              pageSize={10}
              getRowId={(row) => row.id}
            />
          </Box>
        </Box>
      )}

      {type === 2 && (
        <Box sx={{ width: "100%" }}>
          {/* Type 2 Farklı Kaydet */}
          <ByzMuiTreeView data={treeViewData} />

          <Grid
            container
            alignItems={"center"}
            justifyContent={"flex-start"}
            sx={{ marginTop: "8px" }}
          >
            <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
              <ByzMuiTypography
                sx={{
                  textAlign: "left",
                }}
                fontWeight={400}
                fontSize={"5px"}
              >
                {t("print.multi-line")}
              </ByzMuiTypography>
              <ByzMuiCheckBox />
            </Grid>
          </Grid>
        </Box>
      )}

      {type === 3 && (
        <Box sx={{ width: "100%" }}>
          {/* Type 3 Görünümü Kaydet */}
          <ByzMuiTreeView data={treeViewData2} />
        </Box>
      )}
    </Box>
  );
};

export default PrintModal;
